// react-easy-crop の croppedAreaPixels を canvas で切り出して Blob を返すヘルパー
// 円形プレビューでも実体は矩形ファイル（CSSの border-radius で円形表示する想定）

const createImage = (url) =>
  new Promise((resolve, reject) => {
    const image = new Image();
    image.addEventListener('load', () => resolve(image));
    image.addEventListener('error', (error) => reject(error));
    // ローカル ObjectURL を読むので CORS 不要
    image.src = url;
  });

// pixelCrop は { x, y, width, height }（react-easy-crop の onCropComplete 第二引数）
const getCroppedImg = async (
  imageSrc,
  pixelCrop,
  { outputSize = 512, mimeType = 'image/jpeg', quality = 0.9 } = {}
) => {
  const image = await createImage(imageSrc);
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');

  // 出力サイズを固定（記事ページの円形アイコン用に十分な解像度）
  canvas.width = outputSize;
  canvas.height = outputSize;

  ctx.drawImage(
    image,
    pixelCrop.x,
    pixelCrop.y,
    pixelCrop.width,
    pixelCrop.height,
    0,
    0,
    outputSize,
    outputSize
  );

  return new Promise((resolve, reject) => {
    canvas.toBlob(
      (blob) => {
        if (!blob) {
          reject(new Error('画像の生成に失敗しました'));
          return;
        }
        resolve(blob);
      },
      mimeType,
      quality
    );
  });
};

export default getCroppedImg;
